// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2a64B","rootCenter":"LoadMoreObserver_rootCenter__25vUJ","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2NYCF"};